export default "__VITE_ASSET__cb5edd79__"